module.exports = __webpack_public_path__ + "img/sales_analytics.99961006.svg";